import {isFeatureEnabled} from '@github-ui/feature-flags'
import {TabNav} from '@primer/react/deprecated'
import {clsx} from 'clsx'

import styles from './tab-nav.module.css'
import type {ViewSwitchProps} from './types'

export const TabNavViewSwitch = ({selectedView, onViewSelect, onLoadPreview, disabled}: ViewSwitchProps) => {
  const hybridEnabled = isFeatureEnabled('markdown_experience_hybrid_editor')

  return (
    <div className={styles.viewSwitch}>
      <TabNav aria-label="View mode">
        <TabNav.Link
          as="button"
          selected={selectedView === 'edit'}
          disabled={disabled}
          className={clsx(styles.tabNavLink, selectedView === 'edit' && styles.active)}
          onClick={() => onViewSelect?.('edit')}
        >
          Write
        </TabNav.Link>
        <TabNav.Link
          as="button"
          selected={selectedView === 'preview'}
          disabled={disabled}
          className={clsx(styles.tabNavLink, selectedView === 'preview' && styles.active)}
          onClick={() => onViewSelect?.('preview')}
          onMouseOver={() => onLoadPreview?.()}
          onFocus={() => onLoadPreview?.()}
        >
          Preview
        </TabNav.Link>
        {hybridEnabled && (
          <TabNav.Link
            as="button"
            selected={selectedView === 'hybrid'}
            disabled={disabled}
            className={clsx(styles.tabNavLink, selectedView === 'hybrid' && styles.active)}
            onClick={() => onViewSelect?.('hybrid')}
          >
            Hybrid
          </TabNav.Link>
        )}
      </TabNav>
    </div>
  )
}
